import fluid, { extract, screens, fontSize } from 'fluid-tailwind';

export default {
    content: {
        files: [
            './custom/blocks/**/*.{js,php}',
            './custom/templates/**/*.twig',
            './ecmascript/**/*.js',
        ],
        extract,
    },
    theme: {
        screens,
        fontSize,
        fontFamily: {
            'heading': 'var(--font-heading)',
            'heading-alt': 'var(--font-heading-alt)',
            'body': 'var(--font-body)',
            'body-alt': 'var(--font-body-alt)',
        },
        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            white: 'rgb(var(--color-white))',
            black: 'rgb(var(--color-black))',
            gray: 'rgb(var(--color-gray))',
            'alice-blue': 'rgb(var(--color-alice-blue))',
        },
        extend: {
            backgroundImage: ({ theme }) => ({
                'faded-gray-line': `
                    linear-gradient(
                        to right,
                        ${theme('colors.transparent')},
                        ${theme('colors.white')} 24%,
                        ${theme('colors.white')} 76%,
                        ${theme('colors.transparent')}
                    )
                `,
            }),
            screens: {
                xs: '26.875rem', // 430px
                '3xl': '120rem', // 1920px
            },
            spacing: {
                15: '3.75rem',
                18: '4.5rem',
                30: '7.5rem',
                35: '8.75rem',
                100: '25rem',
            },
            transitionProperty: {
                spacing: 'margin, padding',
                text: 'font-size',
            },
        },
    },
    plugins: [
        require('@tailwindcss/container-queries'),
        fluid,
    ],
};

